module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-post"
  }, [_c('ui-second-title', [_vm._v(_vm._s(_vm.$t('modules.posts.new')))]), _vm._v(" "), _c('post-form', {
    attrs: {
      "type": "create"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79a01580!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modules/Post/NewPost.vue
// module id = 278
// module chunks = 2